/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import { queryOptions, useQuery } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type { FindAllActivitiesQueryResponse } from "../types/FindAllActivities.ts"

export const findAllActivitiesQueryKey = () =>
  [{ url: "/v1/activity/find-all-activities" }] as const

export type FindAllActivitiesQueryKey = ReturnType<
  typeof findAllActivitiesQueryKey
>

/**
 * @summary Find all activities
 * {@link /v1/activity/find-all-activities}
 */
export async function findAllActivities(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindAllActivitiesQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/activity/find-all-activities`,
    ...requestConfig,
  })
  return res
}

export function findAllActivitiesQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findAllActivitiesQueryKey()
  return queryOptions<
    ResponseConfig<FindAllActivitiesQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindAllActivitiesQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return findAllActivities({ ...config, signal: config.signal ?? signal })
    },
  })
}

/**
 * @summary Find all activities
 * {@link /v1/activity/find-all-activities}
 */
export function useFindAllActivities<
  TData = ResponseConfig<FindAllActivitiesQueryResponse>,
  TQueryData = ResponseConfig<FindAllActivitiesQueryResponse>,
  TQueryKey extends QueryKey = FindAllActivitiesQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindAllActivitiesQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? findAllActivitiesQueryKey()

  const query = useQuery(
    {
      ...findAllActivitiesQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
